const CONTEXT_LATEST_DESIGN_VERSION = 12;
export { CONTEXT_LATEST_DESIGN_VERSION };
